'use client';
export { Text } from '@chakra-ui/react';

//# sourceMappingURL=index.js.map